import FilesContainer from './FilesContainer';

export default FilesContainer;
